"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.generate = void 0;
var U = __importStar(require("../utils"));
var DataInterfaceUtils = __importStar(require("./data-interface"));
exports.generate = function (entity, entities, urlPrefix, apiUrl, withBackend, mockData) { return ({
    urlPrefix: urlPrefix + "/" + entity.name + "/detail",
    title: String(entity.name),
    fields: entity.fields.map(function (field) {
        var type = U.mapTypes.get(field.type) || 'autocomplete';
        var isForeignKey = type === 'autocomplete';
        var foreignEntity = U.getEntityByName(field.type, entities);
        var isEnum = type === 'enum';
        var inputProps = field.type === 'LocalDateTime'
            ? { shouldReturnDateObj: true }
            : undefined;
        return {
            name: field.name,
            label: field.name.toString(),
            type: type,
            mandatory: !field.optional,
            inputProps: inputProps,
            promise: isForeignKey
                ? DataInterfaceUtils.listForeignKeyOptions(foreignEntity, apiUrl, withBackend, mockData)
                : undefined,
            options: isEnum ? field.options || [] : undefined,
            render: isForeignKey
                ? function (x) { return U.renderForeignEntity(x, entity, foreignEntity); }
                : isEnum
                    ? function (x) { return U.renderEnum(x, field.name, field.options || []); }
                    : undefined
        };
    })
}); };
